import React from "react";

import Style from "./widget.module.scss";

interface IWidgetProps {
    title: string | React.ReactNode;
    bodyPadding: boolean;
    children: React.ReactNode;
    extraTools?: React.ReactNode;
}

const Widget = React.forwardRef<HTMLDivElement, IWidgetProps>(
    ({ title, bodyPadding, children, extraTools }, ref) => {
        return (
            <div className={Style.main} ref={ref}>
                <div className={Style.header}>
                    {extraTools && (
                        <div className={Style.extra}>{extraTools}</div>
                    )}
                    {title}
                </div>

                <div className={`${bodyPadding ? Style.body : undefined}`}>
                    {children}
                </div>
            </div>
        );
    }
);

export default Widget;
